const o = "_dialog_ekak1_1", t = "_dialogContent_ekak1_9", a = {
  dialog: o,
  dialogContent: t
};
export {
  a as default,
  o as dialog,
  t as dialogContent
};
